import React, { FC, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { ReduxState } from '../../types/app';

const isHomePath = (pathname: string) => pathname === '/' || pathname === '';

const DETAILS_URL = 'https://brokersolution.org/';

const NeedHelpPromo: FC = () => {
  const intl = useIntl();
  const location = useLocation();
  const [visible, setVisible] = useState(true);

  const otherBroker = useSelector(
    (state: ReduxState) => state.Client.data?.OtherBroker
  );
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  if (!mounted || otherBroker || isHomePath(location.pathname) || !visible) {
    return null;
  }

  return createPortal(
    <aside
      className="need-help-promo"
      aria-label={intl.formatMessage({ id: 'files.needHelpPromo.ariaLabel' })}
    >
      <button
        type="button"
        className="need-help-promo__close"
        aria-label={intl.formatMessage({ id: 'files.needHelpPromo.close' })}
        onClick={handleClose}
      />
      <div className="need-help-promo__content">
        <p className="need-help-promo__title">
          <FormattedMessage id="files.needHelpPromo.title" />
        </p>
        <p className="need-help-promo__subtitle">
          <FormattedMessage
            id="files.needHelpPromo.subtitle"
            values={{
              brand: (
                <span className="need-help-promo__brand">
                  <FormattedMessage id="files.needHelpPromo.brand" />
                </span>
              ),
            }}
          />
        </p>
        <a
          className="need-help-promo__button"
          href={DETAILS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="files.needHelpPromo.details" />
        </a>
      </div>
    </aside>,
    document.body
  );
};

export default NeedHelpPromo;
